import React, { useState, useEffect } from "react";
import Select from "react-select";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import asyncRoute from "../../../helpers/hoc/asyncRoute";
import { infoKeys } from "../../../helpers/config/infomateryKeys";
const LocationSelect = ({
  label,
  path,
  type,
  value,
  selectedOptions,
  onChange,
  onRemove,
  selectedLocation,
  setSelectedLocation,
  options,
  placeholderMessage,
  locationApiFunction,
  platformType,
  setLocationPayload,
  locationPayload,
  infoButtonBooleanData = {},
  openInformationModal = () => {},
  infoData = {},
}) => {

  const locationMap = useSelector((state) => get(state, "app.locationMap", ""));
  // console.log("locationMap", locationMap)
  // console.log("selectedOptions", selectedOptions)
  // console.log(options, 'options')


  const [inputValue, setInputValue] = useState('');
  const [includeSelections, setIncludeSelections] = useState(locationMap && locationMap.includedLocation.length > 0 ? locationMap.includedLocation : []);
  const [excludeSelections, setExcludeSelections] = useState(locationMap && locationMap.excludedLocation.length > 0 ? locationMap.excludedLocation : []);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [includeExcludeOptions, setIncludeExcludeOptions] = useState([]);

  // console.log(includeSelections, excludeSelections, '%%%%%%%%%%%%%%%5');
  // let selectedOption = options.find(item => item.value == value.value);
  // console.log("000 selectedOption", selectedOption)
  // setIncludeExcludeOptions([...includeExcludeOptions, selectedOption]);

  const InfoButton = asyncRoute(() => import("../../InfoButton"));


  useEffect(() => {
    if (locationMap) {
      setIncludeSelections(locationMap.includedLocation.length > 0 ? locationMap.includedLocation : [])
      setExcludeSelections(locationMap.excludedLocation.length > 0 ? locationMap.excludedLocation : [])
      // includeSelections.map(location => {
      //   const selectedOption = options.find(item => item.critId === location.value);
      //   // Add the selectedOption to includeExcludeOptions
      //   setIncludeExcludeOptions(prevOptions => [...prevOptions, selectedOption]);
      // });

      // excludedLocation.map(location => {
      //   const selectedOption = options.find(item => item.critId === location.value);
      //   // Add the selectedOption to includeExcludeOptions
      //   setIncludeExcludeOptions(prevOptions => [...prevOptions, selectedOption]);
      // });
    }
  }, [locationMap])

  const DropdownIndicator = () => (
    <div style={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
      <i className="ti ti-search" style={{ fontSize: '18px', position: 'absolute', left: 10, top: 8 }}></i>
    </div>
  );


  const customStyles = {
    control: (provided) => ({
      ...provided,
      paddingLeft: '22px',
      fontSize: 14
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      color: "#394256",
      // backgroundColor: state.isSelected ? '#f0f0f0' : 'white', // Example background color
      // color: state.isSelected ? 'black' : 'inherit', // Example text color
      ':hover': {
        backgroundColor: '#e0e0e0', // Example hover background color
      },
    }),
    menuList: (provided) => ({
      ...provided,
      // Add your custom styles for the menu list here
      backgroundColor: "white",
      borderRadius: "5px 5px 0 0",
      border: "1px solid #DCE3EE",
      borderBottom: "unset"
    }),
  };

  const handleIncludeExcludeChange = (value, type) => {
    console.log(value, type);
    if (isDropdownOpen) {
      let selectedOption = options.find(item => item.value == value.value);
      if (type === "include") {
        if (!includeSelections.some(selection => selection.value === value.value)) {
          setIncludeSelections((prev) => [...prev, { label: value.label, value: value.value }]);
        }
        setExcludeSelections((prev) => prev.filter((place) => place.value !== value.value));
      } else {
        if (!excludeSelections.some(selection => selection.value === value.value)) {
          setExcludeSelections((prev) => [...prev, { label: value.label, value: value.value }]);
        }
        setIncludeSelections((prev) => prev.filter((place) => place.value !== value.value));
      }
      console.log("000 selectedOption", selectedOption)
      setIncludeExcludeOptions([...includeExcludeOptions, selectedOption]);
    }
  };


  const handleApply = () => {
    let includedLocationsPayload = [];
    let excludedLocationsPayload = [];

    if (includeSelections && includeSelections.length > 0) {
      includedLocationsPayload = includeSelections.map(item => {
        console.log("000 includeSelections", includeSelections)
        console.log("000 includeExcludeOptions", includeExcludeOptions)
        let selectedOption = options.find(rec => rec.value == item.value);
        console.log("000 selectedOption", selectedOption)
        if (selectedOption) {
          return {
            inex: 1,
            [platformType]: selectedOption.id,
            value: item.label,
            type: selectedOption.type
          };
        }
      }).filter((data) => data != undefined);
    }

    if (excludeSelections && excludeSelections.length > 0) {
      excludedLocationsPayload = excludeSelections.map(item => {
        let selectedOption = options.find(rec => rec.value == item.value);
        if (selectedOption) {
          return {
            inex: 0,
            [platformType]: selectedOption.id,
            value: item.label,
            type: selectedOption.type
          };
        }
      }).filter((data) => data != undefined);
    }

    console.log([...includedLocationsPayload, ...excludedLocationsPayload], 'LOCATION PAYLOAD');
    setLocationPayload([...locationPayload, ...includedLocationsPayload, ...excludedLocationsPayload])
    setIsDropdownOpen(false);
  };


  const handleCancel = () => {
    // Clear the selections
    // setIncludeSelections([]);
    // setExcludeSelections([]);
    // setSelectedLocation([]);
    setIsDropdownOpen(false); // Close the dropdown after canceling
  };

  const formatOptionLabel = ({ label, value, path, canonicalPath, type }) => {
    // console.log("canonicalPath", canonicalPath)
    // console.log("path", path)
    const item = { label, value };
    console.log(label, value, '%%%%')
    // const matchingOption = includeExcludeOptions.find((option) => option.value === value);

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{label + "  >  " + (path ? path : canonicalPath) + "  >  " + type}</span>
        <div
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <input
            type="radio"
            id={`includeLocation-${value}`}
            checked={includeSelections.some(selection => selection.value == value)}
            onChange={() => handleIncludeExcludeChange(item, "include")}
            onClick={() => setIsDropdownOpen(true)} // Open the dropdown when the radio is clicked
          />
          <label
            htmlFor={`includeLocation-${value}`}
            style={{ margin: "0 5px 0 5px", fontSize: 12, }}
          >
            Include
          </label>
          <input
            type="radio"
            id={`excludeLocation-${value}`}
            checked={excludeSelections.some(selection => selection.value == value)}
            onChange={() => handleIncludeExcludeChange(item, "exclude")}
            onClick={() => setIsDropdownOpen(true)} // Open the dropdown when the radio is clicked
          />
          <label htmlFor={`excludeLocation-${value}`}
            style={{ margin: "0 5px 0 5px", fontSize: 12, }}
          >Exclude</label>
        </div>
      </div>
    )
  };


  const handleRemove = (removedOption) => {
    // Check if the option is in includeSelections or excludeSelections
    const isInIncludeSelections = includeSelections.includes(removedOption);
    const isInExcludeSelections = excludeSelections.includes(removedOption);

    if (isInIncludeSelections) {
      // If the option is in includeSelections, remove it from includeSelections
      setIncludeSelections((prev) => prev.filter((place) => place !== removedOption));
    } else if (isInExcludeSelections) {
      // If the option is in excludeSelections, remove it from excludeSelections
      setExcludeSelections((prev) => prev.filter((place) => place !== removedOption));
    }

    // Call the onRemove callback
    setLocationPayload(locationPayload.filter((dataLocation) => dataLocation[platformType] != removedOption.value))
    onRemove(removedOption);
  };


  const handleInputChange = (value) => {
    setInputValue(value);
  };


  useEffect(() => {
    const debouncedSearch = setTimeout(() => {
      locationApiFunction(inputValue);
    }, 500);

    return () => clearTimeout(debouncedSearch);
  }, [inputValue]);

  return (
    <div className="location-adj form-group row">
      <label className="col-12 col-form-label">
        {label}
        {platformType == "meta" &&
          <span className="text-danger">*</span>
        }
        <InfoButton
          infoIcon={infoButtonBooleanData[infoKeys.location]}
          onInfoClick={() => {
            openInformationModal(infoData[infoKeys.location]);
          }}
        />
      </label>
      <div className="col-md-12">
        <div className="custom-select-wrapper">
          <Select
            value={selectedOptions}
            onChange={onChange}
            options={options}
            isMulti
            isSearchable
            placeholder={placeholderMessage}
            formatOptionLabel={formatOptionLabel}
            menuIsOpen={isDropdownOpen} // Control whether the dropdown is open
            styles={customStyles} // Apply custom styles to the menu list
            inputValue={inputValue}
            onInputChange={handleInputChange}
            components={{
              DropdownIndicator: DropdownIndicator, // Hide default dropdown indicator
              Menu: (props) => (
                <div>
                  {props.children}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      background: "#F7F7F8",
                      padding: 10,
                      paddingBottom: 12,
                      borderRadius: "0 0 5px 5px",
                      border: "1px solid #DCE3EE"
                    }}
                  >
                    <button
                      className="btn btn-secondary mr-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleApply}
                    >
                      Add
                    </button>
                  </div>
                </div>
              ),
            }}
            onFocus={() => setIsDropdownOpen(true)} // Handle input focus
          />
        </div>
      </div>
      <div className="row mx-0">
        {includeSelections.length > 0 && (
          <div className="col-md-6 tags-container px-0" style={{ border: "1px solid #288e4921" }}>
            {includeSelections.map((option) => (
              <span key={option} className="tag">
                <i className="mdi mdi-check-circle"
                  style={{ fontSize: 14, color: "#288E49" }}
                ></i>
                {option.label}
                <i
                  className="ti ti-x"
                  style={{ fontSize: 15, cursor: "pointer" }}
                  onClick={() => handleRemove(option)}
                ></i>
              </span>
            ))}
          </div>
        )}
        {excludeSelections.length > 0 && (
          <div className="col-md-6 tags-container px-0" style={{ border: "1px solid #e0473229" }}>
            {excludeSelections.map((option) => (
              <span key={option} className="tag">
                <i className="mdi mdi-close-circle"
                  style={{ fontSize: 14, color: "#E04732" }}
                ></i>
                {option.label}
                <i
                  className="ti ti-x"
                  style={{ fontSize: 15, cursor: "pointer" }}
                  onClick={() => handleRemove(option)}
                ></i>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSelect;
